import { useState } from "react";
import { t } from "@/i18n";
import { DemoBadge } from "./States";
import { ImageOff } from "lucide-react";

import { resolveBackendUrl } from "@/lib/backendUrl";

export const resolveMediaUrl = resolveBackendUrl;

const MediaFrame = ({
  asset,
  className = "",
  fit = "cover",
  showBadge = true,
  controls = false,
  testId,
  emptyMessage,
  onError,
}) => {
  // El error de carga se asocia a la URL: al cambiar de activo no se arrastra el estado "fallido".
  const [failedUrl, setFailedUrl] = useState(null);
  const mediaUrl = asset ? resolveMediaUrl(asset.url) : "";
  const failed = Boolean(asset) && failedUrl === mediaUrl;

  if (!asset) {
    return (
      <div
        data-testid={testId || "media-empty"}
        className={`v-media flex flex-col items-center justify-center gap-1.5 p-2 text-center text-[#6b6b6b] ${className}`}
      >
        <ImageOff size={18} className="opacity-40" />
        <span className="text-[10px] text-[#737373] select-none font-medium">
          {emptyMessage || t.canvas?.noAsset || "Sin imagen asignada"}
        </span>
      </div>
    );
  }

  return (
    <div
      data-testid={testId || `media-${asset.id}`}
      className={`v-media ${fit === "contain" ? "flex items-center justify-center bg-[#121212]" : ""} ${className}`}
    >
      {asset.type === "video" ? (
        <video
          key={asset.id}
          src={mediaUrl}
          controls={controls}
          preload="metadata"
          playsInline
          onError={(e) => {
            setFailedUrl(mediaUrl);
            onError?.(e);
          }}
          className={`max-h-full max-w-full ${fit === "contain" ? "h-full w-full object-contain" : "h-full w-full object-cover"}`}
        />
      ) : failed ? (
        <div className="flex h-full w-full flex-col items-center justify-center gap-1 text-[#6b6b6b]">
          <ImageOff size={18} className="opacity-40" />
          <span className="text-[11px] text-[#737373]">{t.editor.error}</span>
        </div>
      ) : (
        <img
          src={mediaUrl}
          alt={asset.label || ""}
          loading="lazy"
          onError={(e) => {
            setFailedUrl(mediaUrl);
            onError?.(e);
          }}
          className={`max-h-full max-w-full ${fit === "contain" ? "h-full w-full object-contain" : "h-full w-full object-cover"}`}
          draggable={false}
        />
      )}
      {showBadge && asset.isDemo && <DemoBadge className="absolute left-2 top-2 bg-[#101010]/80 backdrop-blur" />}
      {showBadge && asset.source === "simulation" && (
        <span className="absolute right-10 top-2 rounded px-1.5 py-0.5 text-[10px] font-semibold bg-[#f5b544]/20 text-[#f5b544] border border-[#f5b544]/30 backdrop-blur">
          SIM
        </span>
      )}
    </div>
  );
};

export { MediaFrame };
export default MediaFrame;
